"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Asn {
    constructor(response) {
        this.autonomousSystemNumber = response.autonomous_system_number;
        this.autonomousSystemOrganization = response.autonomous_system_organization;
        this.ipAddress = response.ip_address;
    }
}
exports.default = Asn;
